import { ColorName, Colors } from '../../../theme';
import { clamp } from '../../../utils/clamp';
import styles from './ProgressBar.module.scss';

type Props = {
  /**
   * The color of the progress bar.
   * @default 'UiPrimaryStronger'
   */
  color?: ColorName;
  /**
   * The maximum value for the progress bar.
   * @default 1
   */
  max?: number;
  /**
   * The minimum value for the progress bar.
   * @default 0
   */
  min?: number;
  /**
   * The amount of the progress bar. Should be between `min` and `max`.
   */
  value: number;
};

/**
 * Basic progress component. Conveys how close to done or completion something is.
 */
export const ProgressBar = ({
  max = 1,
  min = 0,
  color = 'UiPrimaryStronger',
  value,
}: Props) => {
  const clampedValue = clamp(value, min, max);
  const range = max - min;
  const decimal = (clampedValue - min) / range;
  const width = `${decimal * 100}%`;
  return (
    <div className={styles.root} data-zds>
      <div
        className={styles.progress}
        data-testid="progress"
        data-zds
        style={{
          '--progress-bar-width': width,
          '--progress-bar-color': Colors[color],
        }}
      />
    </div>
  );
};
